import { Form, Input, message, Modal } from "antd";
import { useState, useEffect } from "react";
import { serverFetch } from "@server";
import { fmtDateTimeFull } from "@extensions/utils";
import { tokenVidsLabel } from "@extensions/enums";

const MessageDialog = ({ id, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    serverFetch("dialog")
      .then((data) => {
        const dialog = Array.isArray(data) ? data.find((d) => d.id === id) : null;
        if (dialog) {
          setItem(dialog);
          form.setFieldsValue({ name: dialog.name ?? "" });
        } else {
          message.error("Диалог не найден");
          onClose?.();
        }
      })
      .catch((e) => {
        message.error(e.userMessage || "Ошибка загрузки диалога");
        onClose?.();
      })
      .finally(() => setLoading(false));
  }, [id, form, onClose]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      if (!item) return;
      setLoading(true);
      const payload = { ...item, name: values.name || null };
      serverFetch("dialog", { method: "PUT", bodyData: payload })
        .then(() => {
          message.success("Диалог обновлён");
          onSuccess?.();
          onClose?.();
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage || "Ошибка сохранения");
        });
    });
  };

  return (
    <Modal
      title="Диалог"
      open={!!id}
      onOk={handleSave}
      onCancel={() => onClose?.()}
      okText="Сохранить"
      cancelText="Отмена"
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" disabled={loading}>
        {item && (
          <>
            <Form.Item label="ID"><Input value={item.id} disabled /></Form.Item>
            <Form.Item label="Дата создания"><Input value={item.createdOn ? fmtDateTimeFull(item.createdOn) : ""} disabled /></Form.Item>
            <Form.Item label="Компания (ID)"><Input value={item.companyId} disabled /></Form.Item>
            {item.tokenName != null && item.tokenName !== "" && (
              <Form.Item label="Канал"><Input value={item.tokenName} disabled /></Form.Item>
            )}
            {item.code != null && item.code !== "" && (
              <Form.Item label="Код"><Input value={item.code} disabled /></Form.Item>
            )}
            <Form.Item label="Вид"><Input value={tokenVidsLabel(item.vid) ?? item.vid} disabled /></Form.Item>
            <Form.Item label="Телефон"><Input value={item.phone ?? ""} disabled /></Form.Item>
            <Form.Item label="ID последнего сообщения"><Input value={item.lastMessageId ?? ""} disabled /></Form.Item>
            <Form.Item label="Дата обновления"><Input value={item.lastUpdated ? fmtDateTimeFull(item.lastUpdated) : ""} disabled /></Form.Item>
            {item.lastMessageBody != null && item.lastMessageBody !== "" && (
              <Form.Item label="Текст последнего сообщения"><Input.TextArea value={item.lastMessageBody} disabled rows={3} /></Form.Item>
            )}
          </>
        )}
        <Form.Item name="name" label="Наименование">
          <Input placeholder="Наименование диалога" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MessageDialog;
